import { combineReducers } from '@reduxjs/toolkit';
import LoginReducer from './features/LoginSlice';
import DropdownReducer from './features/DropDownSlice';
import PostJobReducer from './features/PostJobSlice';
import PostActivitySlice from './features/ActivityPostSlice';
import SkillsSlice from './features/SkillSlice';
import EducationSlice from './features/EducationSlice';
import ExperienceSlice from './features/ExperienceSlice';
import AddMoreSlice from './features/AddMoreSectionSlice';
import ProfileSlice from './features/ProfileSlice';
import LikeSlice from './features/LikeSlice';
import CommentSlice from './features/CommentSlice';
import ReactionSlice from './features/ReactionSlice';
import BusinessPlaceSlice from './features/BuinessPlaceSlice';
import SearchSlice from './features/SearchSlice';
import NotificationSlice from './features/NotificationSlice';
import UserResumeSlice from './features/UserResumeSlice';
import SettingsSlice from './features/SettingsSlice';

import CompanySlice from './features/CompanySlice';
import Loading from './services/LoadingService';

const appReducer = combineReducers({
  DropdownReducer,
  PostJobReducer,
  LoginReducer,
  PostActivitySlice,
  SkillsSlice,
  EducationSlice,
  ExperienceSlice,
  ProfileSlice,
  LikeSlice,
  CommentSlice,
  ReactionSlice,
  BusinessPlaceSlice,
  AddMoreSlice,
  CompanySlice,
  Loading,
  SearchSlice,
  NotificationSlice,
  UserResumeSlice,
  SettingsSlice
});

const rootReducer = (state, action) => {
  if (action.type === 'login/HandleClearRedux') {
    localStorage.removeItem('persist:root');
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
